import IMailSubject from "@/interfaces/IMailSubject";
import IState from "@/interfaces/IState";
import { ActionContext } from "vuex";

export default async function createPartner(
  context: ActionContext<IState, IState>,
  data: IMailSubject
) {
  const res = await context.dispatch(
    "backendTalker",
    {
      request: "partner_create",
      data,
    },
    { root: true }
  );

  if (res.status !== 201) {
    return Promise.reject(null);
  }
}
